import type { Clock } from "../sim/clock";
import { blurOnPointerClick, button, playButton, setText } from "./dom";
import { formatJdCompact, formatSpeed } from "./format";
import type { Store } from "./store";

export interface TimePillDeps {
  clock: Clock;
  store: Store;
  onOpenControls(): void;
}

export function mountTimePill(
  container: HTMLElement,
  { clock, store, onOpenControls }: TimePillDeps,
): { el: HTMLElement; refresh(): void } {
  const pill = document.createElement("div");
  pill.className = "time-pill glass";
  const play = playButton(() => {
    clock.paused = !clock.paused;
    refresh();
  }, store);
  blurOnPointerClick(play.el);
  const date = document.createElement("span");
  const utc = document.createElement("span");
  utc.className = "time-pill-utc";
  utc.textContent = " UTC";
  const speed = document.createElement("span");
  speed.className = "time-pill-speed";
  const text = button("", onOpenControls, "time-pill-text");
  text.append(date, utc, speed);
  pill.append(play.el, text);
  container.append(pill);

  const refresh = (): void => {
    play.sync(clock.paused);
    setText(date, formatJdCompact(clock.jd));
    setText(speed, ` · ${formatSpeed(clock.speed, store.state.lang, true)}`);
  };
  refresh();
  return { el: pill, refresh };
}
